import { render, staticRenderFns } from "./Creatives.vue?vue&type=template&id=b5867e1a&scoped=true&"
import script from "./Creatives.vue?vue&type=script&lang=js&"
export * from "./Creatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5867e1a",
  null
  
)

export default component.exports